
/**
 *
 * Plugin for show/hide charatters of password input in register and account page
 *
 * @author: David Pocina <dpocina[at]zerogrey[dot]com>
 *
 */

(function ($, _) { /* global _ */
  'use strict'

  /**
	 * @selector data-zg-role="password-unmask" The plugin start if there is the selector in the dom when the page load
	 */
  const selector = '[data-zg-role="password-unmask"]'

  // PASSWORD UNMASK CLASS DEFINITION
  // =============================

  /**
	 *
	 * @param {HTMLElement} element
	 * @param {!Object}     options
	 *
	 * @constructor
	 */
  const PasswordUnmask = function (element, options) {
    this.$element = $(element)
    this.options = options

    this.$target = $(this.options.target)
    this.$clone = null

    this.__setEventHandlers()
  }

  /**
	 * @param {string} [iconShow] Font awesome for button "show password"
	 * @param {string} [iconHide] Font awesome for button "hide password"
	 * @param {string} [activeClass] Class for the active button
	 * @param {string} target The id of input type password where show or hide password
	 */

  PasswordUnmask.DEFAULTS = {
    iconShow: 'bi-eye-fill',
    iconHide: 'bi-eye-slash-fill',
    activeClass: 'active',
    target: null
  }

  /**
	 *
	 * @private
	 */
  PasswordUnmask.prototype.__setEventHandlers = function () {
    this.$element.on('click.zg.passwordUnmask', (e => {
      e.preventDefault()

      this.__toggle()
    }))
  }

  /**
	 *
	 * @private
	 */
  PasswordUnmask.prototype.__toggle = function () {
    if (this.$element.hasClass(this.options.activeClass)) {
      // hide the password

      this.$element
				.removeClass(this.options.activeClass)
				.find('.bi')
				.addClass(this.options.iconShow)
				.removeClass(this.options.iconHide)

      this.$target.prop('type', 'password')
    } else {
      // display the password as a text field

      this.$element
				.addClass(this.options.activeClass)
				.find('.bi')
				.addClass(this.options.iconHide)
				.removeClass(this.options.iconShow)

      this.$target.prop('type', 'text')
    }
  }

  /**
	 *
	 * @param {Object} options
	 * @private
	 */
  PasswordUnmask.prototype.__setOptions = function (options) {
    _.extendOwn(this.options, options || {})
  }

  // PASSWORD UNMASK PLUGIN DEFINITION
  // =================================

  function Plugin(option) {
    return this.each(function () {
      const $this = $(this)
      const data = $this.data('zg.passwordUnmask')
      const options = _.extend({}, PasswordUnmask.DEFAULTS, window.ZG_CONFIG || {}, $this.data(), typeof option === 'object' && option)

      if (!data) {
        $this.data('zg.passwordUnmask', (new PasswordUnmask(this, options)))
      }
    })
  }

  $.fn.zgPasswordUnmask = Plugin
  $.fn.zgPasswordUnmask.Constructor = PasswordUnmask

  // PASSWORD UNMASK DATA-API
  // ========================

  $(() => {
    $(selector).each(function () {
      Plugin.call($(this))
    })
  })
})(jQuery, _)
